module.exports = __webpack_public_path__ + "img/190f3e489fc2aed63744dcba04e94e0f.png";